<!-- @defer {

  @if (showGoBackTopButton) {
    <div class="goBackTop" (click)="goBackTop()">
      <img src="../assets/icons/arrow_top.svg" alt="Go to back top PJCaba">
    </div>
  }

    <app-nav />

    <router-outlet></router-outlet>

    <app-footer />

} @loading (after 100ms; minimum 1s) {
  <div class="loader">
    <img alt="loading..." src="../assets/gif/loading.gif" />
  </div>
} -->

<!-- <div class="bgLoader">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div> -->

@defer {
  @if (isMenuVisible) {
    <div class="layout" [ngClass]="isSidebar()">
      <!-- <app-sidebar /> -->

      <div class="ctnBody">
        <app-header />
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer />
  } @else {
    <router-outlet></router-outlet>
  }
}

<!-- @placeholder (minimum 1000ms) {
  <app-spinner />
} -->
